import { render, staticRenderFns } from "./commodity.vue?vue&type=template&id=2c090980&scoped=true&"
import script from "./commodity.vue?vue&type=script&lang=ts&"
export * from "./commodity.vue?vue&type=script&lang=ts&"
import style0 from "./commodity.vue?vue&type=style&index=0&id=2c090980&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2c090980",
  null
  
)

export default component.exports